import { useRemoveMember } from "@/features/accounts/api/membersApi";
import { X } from "lucide-react";
import { toast } from "sonner";

type Props = {
  accountId: string;
  accountName: string;
  membershipId: string;
  memberEmail: string;
  open: boolean;
  onClose: () => void;
};

export function RemoveMemberDialog({
  accountId,
  accountName,
  membershipId,
  memberEmail,
  open,
  onClose,
}: Props) {
  const mutation = useRemoveMember(accountId);

  if (!open) return null;

  async function handleConfirm() {
    try {
      await mutation.mutateAsync(membershipId);
      toast.success(`${memberEmail} fue removido de la cuenta.`);
      onClose();
    } catch {
      toast.error("No se pudo remover al miembro. Intentá de nuevo.");
    }
  }

  return (
    <div className="fixed inset-0 z-50 flex items-center justify-center p-4">
      <div
        className="absolute inset-0 bg-black/50"
        onClick={onClose}
        onKeyDown={(e) => {
          if (e.key === "Escape") onClose();
        }}
      />
      <div className="relative z-10 w-full max-w-md rounded-2xl border border-app-border bg-app-surface p-6 shadow-xl">
        <div className="mb-5 flex items-center justify-between">
          <h2 className="font-semibold text-app-ink-1 text-lg tracking-tight">Remover miembro</h2>
          <button
            type="button"
            onClick={onClose}
            className="rounded-lg p-1 text-app-ink-3 hover:bg-app-surface-2"
          >
            <X className="h-4 w-4" />
          </button>
        </div>

        <p className="mb-6 text-app-ink-2 text-sm leading-relaxed">
          ¿Estás seguro? <strong className="text-app-ink-1">{memberEmail}</strong> va a perder
          acceso a <strong className="text-app-ink-1">{accountName}</strong>.
        </p>

        <div className="flex gap-3">
          <button
            type="button"
            onClick={onClose}
            className="flex h-11 flex-1 items-center justify-center rounded-xl border border-app-border font-medium text-app-ink-2 text-sm transition-colors hover:bg-app-surface-2"
          >
            Cancelar
          </button>
          <button
            type="button"
            onClick={handleConfirm}
            disabled={mutation.isPending}
            className="flex h-11 flex-1 items-center justify-center rounded-xl bg-rose-600 font-medium text-sm text-white transition-colors hover:bg-rose-700 disabled:opacity-60"
          >
            {mutation.isPending ? "Removiendo…" : "Sí, remover"}
          </button>
        </div>
      </div>
    </div>
  );
}
